import { types } from '../../../types/types';

export const formsPesquisaCamposReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.FORMS.PESQUISA_CAMPOS:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}

export const formsNovoAtualizaCamposReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.FORMS.NOVOATUALIZA:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}

export const formsPesquisaCategoriasReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.FORMS.PESQUISA_CATEGORIAS:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}